import { baseBUCGet } from '../base/baseBUC';

const str = '';
const decimal = 0.00;
const dateTimeStr = new Date()?.toISOString();

export const purchasePaymentModelGet = ({
    buildingId = '',
    purchaseId = '',
    paymentMethodId = '',
    bankOriginId = '',
    bankId = '',
    bankAccountId = '',
    collectionCashId = '',
    userId = '',
}) => {
    return {
        purchaseId: purchaseId,
        paymentMethodId: paymentMethodId,
        bankOriginId: bankOriginId,
        bankId: bankId,
        bankAccountId: bankAccountId,
        collectionCashId: collectionCashId,
        amount: decimal,
        date: dateTimeStr,
        reference: str,
        remark: str,
        ...baseBUCGet({ buildingId: buildingId, userId: userId, }),
    }
};